<script>

	import { userStore, facturamaClientStore } from '../stores'

	import FacturamaService from '../$services/facturama.services'

	import Spinner from '../$components/spinner.svelte'
	import CreateClientComponent from './component.create.client.svelte'
	import InvoiceAmountComponent from './component.invoice.amount.svelte'
	import InvoicesComponent from './component.invoices.svelte'
	import ClientComponent from './component.client.svelte'
	import CreateInvoiceComponent from './component.createInvoice.svelte'

	$: $userStore.facturamaId && getClient();

	let loading = false

	async function getClient() {
		loading = true
		
		const resp = await FacturamaService.getClient(
			$userStore.userId,
			$userStore.facturamaId
		)
		
		loading = false;

		if(!resp.success) return facturamaClientStore.set(null)

		facturamaClientStore.set(resp.data)
	}

</script>

<Spinner {loading} />

{#if !loading}
	{#if !$userStore.facturamaId}
		<CreateClientComponent />
	{:else}
		<InvoiceAmountComponent />
		<div class='columns'>
			<div class='column'>
				<ClientComponent />
			</div>
		</div>
		<div class='columns'>
			<div class='column'>
				<CreateInvoiceComponent />
			</div>
		</div>
		<InvoicesComponent />
	{/if}
{/if}
